/**
 * Ngrx store.
 */
import { createReducer, on } from '@ngrx/store';
import * as SignupAction from '../../actions/signup/signup.actions';

/**
 * Models imports.
 */
import { SignupChatbot, UpdateConsent, CountryList, RegionList, CityList, HospitalList } from './../../../models/sign-up-chatbot.model';

/**
 * This is used to store the signup chatbot detail.
 */
export const signupFeatureKey = 'signup';

export interface State {
  signupConsent: SignupChatbot;
  updateConsent: UpdateConsent;
  countryList: CountryList;
  hospitalList: any;
  clinicList: any;
  usersList: any;
  regionsList: RegionList;
  citiesList: CityList;
  formSubmittedId: number;
  fileUploadUrl: string;
  fileUploadStatus: string;
  presignedUrl: string;
  error: Error;
  resendOtp: boolean;
  profileSubmitResponse: {formId: number, status: string} | null;
  otpExpired: boolean | null;
  prescriptionUpdateResponse: any;
  patientOrderResponse: any;
}

export const initialState: State = {
  signupConsent: null,
  updateConsent: null,
  countryList: null,
  hospitalList: null,
  clinicList: null,
  usersList: null,
  regionsList: null,
  citiesList: null,
  formSubmittedId: null,
  fileUploadUrl: null,
  fileUploadStatus: null,
  presignedUrl: null,
  error: null,
  resendOtp: false,
  profileSubmitResponse: null,
  otpExpired: null,
  prescriptionUpdateResponse: null,
  patientOrderResponse: null
};

export const reducer = createReducer(
  initialState,
  on(SignupAction.setSignupConsentData, (state, payload) => ({
    ...state,
    signupConsent: payload.signupConsent
  })),
  on(SignupAction.setUpdateConsentData, (state, payload) => ({
    ...state,
    updateConsent: payload.updateData
  })),
  on(SignupAction.setCountriesList, (state, payload) => ({
    ...state,
    countryList: payload.countryList
  })),
  on(SignupAction.setHospitalList, (state, payload) => ({
    ...state,
    hospitalList: payload.hospitalList
  })),
  on(SignupAction.setClinicList, (state, payload) => ({
    ...state,
    clinicList: payload.clinicList
  })),
  on(SignupAction.setUsersList, (state, payload) => ({
    ...state,
    usersList: payload.usersList
  })),
  on(SignupAction.setRegionsList, (state, payload) => ({
    ...state,
    regionsList: payload.regionsList
  })),
  on(SignupAction.setCitiesList, (state, payload) => ({
    ...state,
    citiesList: payload.citiesList
  })),
  on(SignupAction.setFormSubmittedId, (state, payload) => ({
    ...state,
    formSubmittedId: payload.formSubmittedId
  })),
  on(SignupAction.setFileUploadUrl, (state, payload) => ({
    ...state,
    fileUploadUrl: payload.fileUploadUrl
  })),
  on(SignupAction.setFileUploadStatus, (state, payload) => ({
    ...state,
    fileUploadStatus: payload.fileUploadStatus
  })),
  on(SignupAction.resetFileUploadUrl, (state, payload) => ({
    ...state,
    fileUploadUrl: payload.fileUploadUrl
  })),
  on(SignupAction.resetFileUploadStatus, (state, payload) => ({
    ...state,
    fileUploadStatus: payload.fileUploadStatus
  })),
  on(SignupAction.resetformSubmittedId, (state, payload) => ({
    ...state,
    formSubmittedId: payload.formSubmittedId
  })),
  on(SignupAction.setFilePresignedUrl, (state, payload) => ({
    ...state,
    presignedUrl: payload.presignedUrl
  })),
  on(SignupAction.resetFilePresignedUrl, (state, payload) => ({
    ...state,
    presignedUrl: payload.presignedUrl
  })),
  on(SignupAction.setErrors, (state, payload) => ({
    ...state,
    error: payload.error
  })),
  on(SignupAction.resetCountryList, (state, payload) => ({
    ...state,
    countryList: initialState.countryList
  })),
  on(SignupAction.setRequestResendOtp, (state, payload) => ({
    ...state,
    resendOtp : payload.resendOtp
  })),
  on(SignupAction.resetErrors, (state) => ({
    ...state,
    error: null
  })),
  on(SignupAction.profileSubmitResponse, (state, payload) => ({
    ...state,
    profileSubmitResponse: payload.data
  })),
  on(SignupAction.resetProfileSubmitResponse, (state) => ({
    ...state,
    profileSubmitResponse: null
  })),
  on(SignupAction.setOtpExpired, (state,payload) => ({
    ...state,
    otpExpired: payload.otpExpired
  })),
  on(SignupAction.setPrescriptionUpdateResponse, (state,payload) => ({
    ...state,
    prescriptionUpdateResponse: payload.data
  })),
  on(SignupAction.setPatientOrderResponse, (state, payload) => ({
    ...state,
    patientOrderResponse: payload.data
  }))
);
